/* MetaPro / Kiddoveda theme — interactions */
(function () {
  'use strict';

  /* Mobile nav drawer */
  document.addEventListener('click', function (e) {
    var drawer = document.querySelector('.mobile-nav');
    if (!drawer) return;
    if (e.target.closest('[data-nav-open]')) {
      drawer.classList.add('open'); document.body.style.overflow = 'hidden';
    }
    if (e.target.closest('[data-nav-close]') || (drawer.classList.contains('open') && e.target.closest('.mobile-nav a'))) {
      drawer.classList.remove('open'); document.body.style.overflow = '';
    }
  });

  /* Scroll reveal */
  var reveals = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* Seamless marquee */
  document.querySelectorAll('.marquee__track').forEach(function (track) {
    if (track.dataset.cloned) return;
    track.dataset.cloned = '1';
    track.innerHTML += track.innerHTML;
  });

  /* Live cart count */
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
        el.style.display = c.item_count > 0 ? 'grid' : 'none';
      });
    }).catch(function () {});
  }
  refreshCart();
  document.addEventListener('cart:updated', refreshCart);
})();
